import { useStaticQuery, graphql } from 'gatsby';

const useMap = () => {
  const data = useStaticQuery(graphql`
    query useMapQuery {
      sanityMap {
        addMapToAllPages
        header {
          tagline
          headline
          _rawDescription
        }
      }
    }
  `);

  const map = data.sanityMap;

  return map;
};

export { useMap };
